import React, { useContext } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { getAmountInCent } from '../../data/utils/getAmountInCent';
import { getConfiguration } from '../../data/utils/configuration';
import { getLocaleDotRound } from '../../data/utils/getLocaleDotRound';
import { getPrintableAmount } from '../../data/utils/getPrintableAmount';
import { getValidAmountString } from '../../data/utils/getValidAmountString';

function StakesPicker(props) {
    const betslipContext = useContext(BetslipContext);
	let betslipData = betslipContext.getBetslipData();
	let conf = getConfiguration();
	let mult = conf.cs.m;
	let nDec = conf.cs.nd;
	const charDecimalBrowser = getLocaleDotRound().round;
	const charThousandBrowser = getLocaleDotRound().dot;
    const couponKey = props.couponKey;
    const coupon = betslipData.coupons[couponKey];

    const isEventForm = props.isEventForm;
    let event = null;
    if (isEventForm) {
    	const pal = props.pal;
    	const avv = props.avv;
    	if (coupon != null) {
    		for (var key in coupon.selections) {
    			var selection = coupon.selections[key];
    			if (selection.pal === pal && selection.avv === avv) {
    				event = selection;
    			}
    		}
    	}
    }
    
    // the amount we use to make calcs
    let amount = isEventForm && event ? event.bets[0].amount : coupon.amountMulti;
    
    function setAmount(settedAmount) {
        // get a valid input field value for this amount: only number and dot, and max nDec digit after it
        settedAmount = getValidAmountString(settedAmount, nDec);
        // putting the "browser decimal dot" instead of the "." for the float type
        let fieldTextValue = settedAmount;
        fieldTextValue = fieldTextValue.replace(".", charDecimalBrowser);
        let amountCentToSet = amount; // last valid amount
        
        // if is number, I calculate the new amount and I keep it into the field value. 
        // If not, I keep the field but I use the last valid amount for the calcs
        if (!isNaN(settedAmount) && settedAmount.length > 0) {
            amountCentToSet = getAmountInCent(parseFloat(settedAmount), mult);
        }
        
        if (isEventForm) {
            if (event != null) {
                const scomSogei = props.scomSogei;
                const handicap = props.handicap;
                const draw = props.draw;
                for (let km in event.bets) {
                    const bet = event.bets[km];
                    if (bet.scomSogei == scomSogei && bet.handicap == handicap && bet.draw === draw) {
                        bet.amount = amountCentToSet;
                        bet.printableAmount = fieldTextValue;
                    }
                }
            }
        } else {
            coupon.amountMulti = amountCentToSet;
            coupon.printableAmountMulti = fieldTextValue;
        }
        
        betslipContext.setBetslipData(betslipData, true);
    }
    
    function setAmountFromCalc(amountCalc){
        amountCalc = getPrintableAmount(amountCalc, mult, nDec);
        amountCalc = amountCalc.replaceAll(charThousandBrowser, ''); // remove the thousand char from the string. In the setAmount only "decimal" is permitted
        setAmount(amountCalc);
    }

    return (
        <div className="bottoni-calc mb-2">
            {conf.bak.vls.map(a =>
                <input key={a} type="button" onClick={() => setAmountFromCalc(a)} value={getPrintableAmount(a, mult, nDec)} />
            )}
        </div>
    );
}

export default StakesPicker;